import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesRealmanAvatarPictureOmniV15Params {
  /**
   * 人物肖像图片URL地址
   */
  image_url: string;
  /**
   * 音频URL地址,音频时长必须小于35秒
   */
  audio_url: string;
  /**
   * 遮罩图片URL列表(来自主体检测步骤2)
   */
  mask_url?: string[];
  /**
   * 随机种子,-1表示随机生成(默认值)
   */
  seed?: number;
  /**
   * 文本提示词,支持中文、英文、日文、韩文、西班牙文、印尼文
   */
  prompt?: string;
  /**
   * 是否启用快速模式(默认值:false)
   */
  pe_fast_mode?: boolean;
}

export interface VolcesRealmanAvatarPictureOmniV15Resource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_realman_avatar_picture_omni_v15
 *
 * API Documentation: https://www.volcengine.com/docs/85621/1829013
 * 
 * Volces RealMan Avatar Picture Omni V1.5 (OmniHuman1.5) 数字人生成接口,支持单张图片+音频生成数字人视频。支持任意宽高比图片,可处理人物、宠物、动漫等多种主体类型。
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesRealmanAvatarPictureOmniV15 } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesRealmanAvatarPictureOmniV15({
 *   // 参数见 VolcesRealmanAvatarPictureOmniV15Params 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesRealmanAvatarPictureOmniV15Params 接口定义
 * @returns 生成的资源列表
 */
export async function volcesRealmanAvatarPictureOmniV15(
  params: VolcesRealmanAvatarPictureOmniV15Params,
): Promise<VolcesRealmanAvatarPictureOmniV15Resource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 5000,
    maxAttempts: 120,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_realman_avatar_picture_omni_v15',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesRealmanAvatarPictureOmniV15Resource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
